import styled from "styled-components";

export default styled.div`
    .file-list {
        list-style: none;
        padding: 0;
        margin: 0 0 1rem 0;
        max-height: 280px;
        overflow-y: auto;
    }

    .file-item {
        display: flex;
        align-items: center;
        padding: 0.5rem 0;
        border-bottom: 1px solid #eee;
        cursor: pointer;

        &:hover {
            background: #f5f5f5;
        }

        &.selected {
            background: #e3f2fd;
        }
    }

    .file-name {
        font-weight: 500;
        margin-right: 0.5rem;
    }

    .file-type {
        color: #666;
        font-size: 0.875rem;
    }

    .actions {
        display: flex;
        justify-content: flex-end;
        gap: 0.5rem;
        margin-top: 1rem;
    }
`;
